import React, { createContext, useEffect, useState } from 'react'
import DashboardHeader from './DashboardHeader'
import DashboardSidebar from './DashboardSidebar'
import Backdrop from '../../components/common/Backdrop'
import Breadcrumbs from '../../components/common/Breadcrumbs'
import { staticSidebarOptions } from '@/static/static'
import { useLocation } from 'react-router-dom';

export const DashboardContext = createContext(null);

const DashboardMaster = ({ children }) => {
    const [toggleMiniSidebar, setToggleMiniSidebar] = useState(false);
    const [toggleResponsiveSidebar, setToggleResponsiveSidebar] = useState(false);
    const { pathname } = useLocation();
    const [currentNode, setCurrentNode] = useState(getDefaultNode());
    const [allSidebarFeeds, setAllSidebarFeeds] = useState([]);
    const [allSidebarBoards, setAllSidebarBoards] = useState([]);
    const [sidebarActiveFeed, setSidebarActiveFeed] = useState(null);
    // feed model open
    const [isOpen, setIsOpen] = useState(false);
    const [currentActiveFeedDetail, setCurrentActiveFeedDetail] = useState(null);
    const [currentAnnotationSpaceDetail, setCurrentAnnotationSpaceDetail] = useState(null);
    const [allSidebarSpaces, setAllSidebarSpaces] = useState([]);
    const [selectedSpace, setSelectedSpace] = useState(null);

    useEffect(() => {
        // Load the currentNode from localStorage or set default
        const storedNode = getCurrentNode() || getDefaultNode();
        setCurrentNode(storedNode);
    }, [pathname]);

    function getCurrentNode() {
        const path = pathname.split("/")?.filter((path) => path !== "")[0];
        if (path === localStorage.getItem("currentNode")) {
            return localStorage.getItem("currentNode");
        } else {
            return path;
        }
    }

    function getDefaultNode() {
        const path = pathname.split("/")?.filter((path) => path !== "")[0];
        const sidebarOption = staticSidebarOptions.find(option => option.nodeTitle === path);

        return sidebarOption?.nodeTitle ? sidebarOption?.nodeTitle : null;
    }

    useEffect(() => {
        // Persist the currentNode to localStorage whenever it changes
        if (currentNode) {
            localStorage.setItem("currentNode", currentNode);
        }
    }, [currentNode]);

    // for currentActiveFeedDetail
    useEffect(() => {
        const storedValue = JSON.parse(localStorage.getItem("currentActiveFeedDetail")) || { label: "All", value: "all" };
        setCurrentActiveFeedDetail(storedValue);
    }, []);

    useEffect(() => {
        if (currentActiveFeedDetail) {
            localStorage.setItem("currentActiveFeedDetail", JSON.stringify(currentActiveFeedDetail));
        }
    }, [currentActiveFeedDetail]);

    // for currentAnnotationSpaceDetail
    useEffect(() => {
        const storedValue = JSON.parse(localStorage.getItem("currentAnnotationSpaceDetail")) || { label: "All", value: "all" };
        setCurrentAnnotationSpaceDetail(storedValue);
    }, []);

    useEffect(() => {
        if (currentAnnotationSpaceDetail) {
            localStorage.setItem("currentAnnotationSpaceDetail", JSON.stringify(currentAnnotationSpaceDetail));
        }
    }, [currentAnnotationSpaceDetail]);

    const contextData = {
        currentNode,
        setCurrentNode,
        allSidebarFeeds,
        setAllSidebarFeeds,
        allSidebarBoards,
        setAllSidebarBoards,
        sidebarActiveFeed,
        setSidebarActiveFeed,
        currentActiveFeedDetail,
        setCurrentActiveFeedDetail,
        allSidebarSpaces,
        setAllSidebarSpaces,
        currentAnnotationSpaceDetail,
        setCurrentAnnotationSpaceDetail,
        setSelectedSpace,
        selectedSpace
    }

    return (
        <DashboardContext.Provider value={contextData}>
            <div className='dashboard-layout bg-backgroundV1 min-h-screen'>
                <DashboardHeader toggleResponsiveSidebar={toggleResponsiveSidebar} setToggleResponsiveSidebar={setToggleResponsiveSidebar} toggleMiniSidebar={toggleMiniSidebar} currentNode={currentNode} setCurrentNode={setCurrentNode} />
                <DashboardSidebar setToggleResponsiveSidebar={setToggleResponsiveSidebar} toggleResponsiveSidebar={toggleResponsiveSidebar} setToggleMiniSidebar={setToggleMiniSidebar} toggleMiniSidebar={toggleMiniSidebar} currentNode={currentNode} setCurrentNode={setCurrentNode} allSidebarFeeds={allSidebarFeeds} setAllSidebarFeeds={setAllSidebarFeeds} allSidebarBoards={allSidebarBoards} setAllSidebarBoards={setAllSidebarBoards} sidebarActiveFeed={sidebarActiveFeed} setSidebarActiveFeed={setSidebarActiveFeed} isOpen={isOpen} setIsOpen={setIsOpen} currentActiveFeedDetail={currentActiveFeedDetail} setCurrentActiveFeedDetail={setCurrentActiveFeedDetail} setAllSidebarSpaces={setAllSidebarSpaces} allSidebarSpaces={allSidebarSpaces} setCurrentAnnotationSpaceDetail={setCurrentAnnotationSpaceDetail} currentAnnotationSpaceDetail={currentAnnotationSpaceDetail} />
                <main className={`dashboard-layout-main transition-all duration-300 ${toggleMiniSidebar ? "lg:ps-[80px]" : "lg:ps-[260px]"} pt-[56px] min-h-[inherit]`}>
                    <div className="dashboard-pages-wrapper">
                        <section className='p-2 pt-7 md:px-5'>
                            <Breadcrumbs />
                        </section>
                        {children}
                    </div>
                </main>
                <Backdrop onClose={() => setToggleResponsiveSidebar(false)} show={toggleResponsiveSidebar} />
            </div>
        </DashboardContext.Provider>
    )
}

export default DashboardMaster 